export default "__VITE_ASSET__nZFC5qEF__"